import { createSelector } from 'reselect';
import ProfileConstants from '@account/const/Profile';

export const getPortfolios = ({ portfolios = {} }) => portfolios;

export const getByChainId = createSelector(
  getPortfolios,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'byChainId' does not exist on type '{}'.
  (portfolios) => portfolios.byChainId,
);

export const getSelectedItemIds = createSelector(
  getPortfolios,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedItemIds' does not exist on type ... Remove this comment to see the full error message
  (portfolios) => portfolios.selectedItemIds,
);

export const getSelectedItemCount = createSelector(
  getPortfolios,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedItemIds' does not exist on type ... Remove this comment to see the full error message
  ({ selectedItemIds = [] }) => selectedItemIds.length,
);

export const getSelectedItems = createSelector(
  getByChainId,
  getSelectedItemIds,
  (byChainId, ids) => ids.map((id) => byChainId[id]),
);

export const getIsSelected = (state, id) => {
  const ids = getSelectedItemIds(state);
  return ids.includes(id);
};

export const getIdsByTypeStatus = (state, type, status) => {
  const portfoliosState = getPortfolios(state);
  return portfoliosState[`${type}-${status}-ids`];
};

export const getPortfoliosByTypeStatus = (state, type, status) => {
  const byChainId = getByChainId(state);
  const ids = getIdsByTypeStatus(state, type, status);
  return ids.map((id) => byChainId[id]);
};

export const getStats = createSelector(
  getPortfolios,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'stats' does not exist on type '{}'.
  ({ stats = {} }) => stats,
);
export const getBuyingStats = createSelector(
  getStats,
  ({ buying = {} }) => buying,
);
export const getSellingStats = createSelector(
  getStats,
  ({ selling = {} }) => selling,
);

export const getPaging = (state, type, status) => {
  const portfoliosState = getPortfolios(state);
  return portfoliosState[`${type}-${status}-paging`];
};

export const getSearchResultPortfolioIds = createSelector(
  getPortfolios,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'searchResultIds' does not exist on type ... Remove this comment to see the full error message
  (portfolios) => portfolios.searchResultIds,
);

export const getSearchResultPortfolios = createSelector(
  getSearchResultPortfolioIds,
  getByChainId,
  (portfolios, byId) => portfolios.map((id) => byId[id]),
);

export const getPortfolioItemByChainId = (state, chainId) => {
  const byChainId = getByChainId(state);
  return chainId ? byChainId[chainId] : {};
};

const getBulkShippingHubIds = (state) =>
  state.customer?.bulkShippingEligibility?.bulkShipmentDestinations || [];

export const getShipmentItemMatch = createSelector(
  getPortfolioItemByChainId,
  getBulkShippingHubIds,
  getSelectedItems,
  (item, eligibleHubs, selectedItems): boolean =>
    eligibleHubs.includes(item?.hubId?.toString()) &&
    (!selectedItems?.length ||
      selectedItems?.every(
        ({ hubId, product }) =>
          hubId === item.hubId &&
          product?.contentGroup === item.product?.contentGroup,
      )),
);

export const getProductTypeMatch = createSelector(
  getPortfolioItemByChainId,
  getSelectedItems,
  (item, selectedItems): boolean =>
    !selectedItems?.length ||
    selectedItems?.every(
      ({ product }) => product?.contentGroup === item.product?.contentGroup,
    ),
);

export const getEligibleAuthDestination = createSelector(
  getPortfolioItemByChainId,
  getBulkShippingHubIds,
  (item, eligibleHubs) => eligibleHubs.includes(item?.hubId?.toString()),
);

export const getShowBulkAction = createSelector(
  getPortfolios,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'showBulkAction' does not exist on type '... Remove this comment to see the full error message
  ({ showBulkAction }) => !!showBulkAction,
);

export const getIsPortfolioTableLoading = (state, type, status) => {
  const portfolioState = getPortfolios(state);
  return portfolioState[`loading-${type}-${status}`];
};

export const getDoesPortfolioTableHaveError = (state, type, status) => {
  const portfolioState = getPortfolios(state);
  return Boolean(portfolioState[`error-${type}-${status}`]);
};

export const getPendingTotal = createSelector(getPortfolios, (portfolios) => {
  // eslint-disable-next-line max-len
  const portfolioPaging =
    portfolios[
      `${ProfileConstants.types.SELLING}-${ProfileConstants.statuses.PENDING}-paging`
    ];

  return portfolioPaging?.total ?? 0;
});

export const getIsExpired = createSelector(
  getPortfolioItemByChainId,
  (item) => {
    if (!item) {
      return;
    }

    const expiration = new Date(item.expiresAt);
    const now = new Date();

    return expiration.getTime() < now.getTime();
  },
);
